import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import es from '@/locales/es.json';

// Get saved language preference or default to English
const savedLanguage = localStorage.getItem('preferredLanguage');
const defaultLocale = savedLanguage && ['en', 'es'].includes(savedLanguage) ? savedLanguage : 'en';

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: defaultLocale, // Default locale
  fallbackLocale: 'en', // Fallback locale
  messages: {
    en,
    es,
  },
  // Global configuration
  globalInjection: true,
  silentTranslationWarn: import.meta.env.MODE === 'production',
  missingWarn: import.meta.env.MODE !== 'production',
  fallbackWarn: import.meta.env.MODE !== 'production',
});

export default i18n;
